import { API } from "aws-amplify";

export type CallContentField = "messages" | "prompt" | "response";

export const fetchCallLargeContent = async (
  callId: string,
  fieldType: CallContentField
): Promise<string> => {
  const result = (await API.get(
    "eventapi",
    `/getCallLargeContentDownloadUrl/${encodeURIComponent(callId)}/${fieldType}`,
    { queryStringParameters: { includeContent: "true" } }
  )) as { content?: unknown };

  if (typeof result.content !== "string") {
    throw new Error(`No content was returned for ${fieldType}.`);
  }

  return result.content;
};
